const semanticClassNames = {
  root: 'captcha',
} as const;

export default semanticClassNames;
